import { type Common } from '../common.js';
import {
  type CreateValues,
  type PhoneNumberPracticeMapping,
} from '../models/phoneNumber/phoneNumberPracticeMapping.js';

export interface FindAllOptions {
  organizationId: string;
}

export class API {
  common: Common;
  readonly baseEndpoint = '/assistant/phone-number-configurations/practice-mappings';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(options: FindAllOptions): Promise<PhoneNumberPracticeMapping[]> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async create(values: CreateValues): Promise<PhoneNumberPracticeMapping> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, values);
  }

  async delete(id: string): Promise<void> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    await this.common.deleteJSON(url);
  }
}
